import React from 'react'
import { EMPTY_VALUE } from '../../../constants/stringConstants'
import { Tag, TagProps } from './Tag'
import { getTypeResponseTranslation, TypeResponse } from '../../../../../MyStichtingOpenHelpers/src/static'

interface Props extends Omit<TagProps, 'color' | 'children'> {
    typeModel?: TypeResponse
    fallbackProperty?: 'name' | 'value'
}

export const TypeResponseTag = ({ typeModel, fallbackProperty = 'value', ...tagProps }: Props) => {
    if (!typeModel) return EMPTY_VALUE
    const translation = getTypeResponseTranslation(typeModel, typeModel[fallbackProperty] ?? undefined)

    return (
        <Tag color={typeModel.color} {...tagProps}>
            {translation}
        </Tag>
    )
}
